// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-div {
	padding-block: 1rem;
}

.loading-div > .spinner-border-lg {
	width: 4rem;
	height: 4rem;
}

.loading-div > .spinner-text {
	display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/loading.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,cAAc;AACf","sourcesContent":[".loading-div {\n\tpadding-block: 1rem;\n}\n\n.loading-div > .spinner-border-lg {\n\twidth: 4rem;\n\theight: 4rem;\n}\n\n.loading-div > .spinner-text {\n\tdisplay: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
